import Mutations from '../../odata/mutations';

export default { ...new Mutations('stockType'), ...new Mutations('stockTypes') };
